import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  web_fcm_token: null,
  loading: false,
  settings: null,
  // categories: [],
  // currencies: [],
  // listRefreshCounter: 0,
  // itemRefreshCounter: 0,
};

export const UserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    SET_USER: (state, action) => {
      state.user = action.payload;
    },
    SET_WEB_FCM_TOKEN: (state, action) => {
      state.web_fcm_token = action.payload;
    },
    SET_LOADING: (state, action) => {
      state.loading = action.payload;
    },
    SET_SETTINGS: (state, action) => {
      state.settings = { ...state.settings, ...action.payload };
    },
    // SET_CATEGORIES: (state, action) => {
    //   state.categories = action.payload;
    // },
    // SET_CURRENCIES: (state, action) => {
    //   state.currencies = action.payload;
    // },
    // REFRESH_LIST: (state) => {
    //   state.listRefreshCounter += 1;
    // },
    // REFRESH_ITEM: (state) => {
    //   state.itemRefreshCounter += 1;
    // },
  },
});

export const {
  SET_USER,
  SET_WEB_FCM_TOKEN,
  SET_LOADING,
  REFRESH_LIST,
  REFRESH_ITEM,
  SET_CATEGORIES,
  SET_CURRENCIES,
  SET_SETTINGS,
} = UserSlice.actions;

export default UserSlice.reducer;
